var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Blacklist',{staticClass:"black-list",attrs:{"is-read-only":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }